<template>
  <div
    id="login-signup"
    class="page-body"
  >
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div>
            <h1>Sign in</h1>
            <amplify-authenticator hide-toast>
              <amplify-sign-in
                slot="sign-in"
                username-alias="email"
                hide-sign-up="true"
                header-text=""
              />
              <amplify-forgot-password
                slot="forgot-password"
                username-alias="email"
              />
            </amplify-authenticator>
          </div>
        </div>
        <div class="col-lg-6 pb-5">
          <h1>Register an account</h1>
          <p class="mt-5">
            You will need to register if you want to apply for a job with CoActive Care.
            Once registered, you can
          </p>
          <ul>
            <li>Save your application at any time</li>
            <li>Access your application from any device</li>
            <li>Check your application status in real time</li>
          </ul>
          <b-button
            variant="secondary"
            :to="{ name: 'register' }"
          >
            Register new account
          </b-button>
        </div>
      </div>
      <p>
        If you have been given a PIN code from
        a member of CoActive Care staff
        <router-link :to="{name: 'sign-in-pin'}">
          you can use it to login
        </router-link>.
      </p>
      <hr>
      <p>Having trouble signing in?</p>
      <p><a :href="$t('contactUrl')">Contact our support team</a></p>
    </div>
  </div>
</template>

<style>

</style>

<script>
import { Hub } from 'aws-amplify';
import { debounce } from 'lodash';
import { EventBus } from '@switchsystems/coactive-vue-lib';

export default {
  name: 'Login',
  computed: {
  },
  mounted() {
    const debouncedToast = debounce((message) => {
      EventBus.$emit('toast:show', {
        title: 'Authentication Error',
        variant: 'danger',
        'auto-hide-delay': 3000,
        body: message,
      });
    }, 3000, {
      leading: true,
      trailing: false,
    });

    Hub.listen('auth', (data) => {
      const { payload } = data;

      if (payload.event === 'signIn_failure') {
        debouncedToast(payload.data.message);
      }
    });
  },
  unmounted() {
    Hub.remove('auth');
  },
  data() {
    return {
    };
  },
};
</script>
